/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_viewer" | "PdpSharedDetailFramingOptions_viewer">;
    readonly " $refType": "PdpRespDetails_viewer";
};
export type PdpRespDetails_viewer$data = PdpRespDetails_viewer;
export type PdpRespDetails_viewer$key = {
    readonly " $data"?: PdpRespDetails_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '028ccd0c5ddcd9884098f15698059044';
export default node;
